var _defs, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProcore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 72 68.44",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15523;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Procore_Logo_Graphicmark_FC_Black_CMYK")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PROCORE_GRAPHICMARK",
    "data-name": "PROCORE GRAPHICMARK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6,81.17,84.46,93.49H59.54L47.09,72,59.54,50.51H84.46L91.6,62.83H108V51.74a13.52,13.52,0,0,0-14-14H50a13.52,13.52,0,0,0-14,14V92.26a13.52,13.52,0,0,0,14,14H94a13.52,13.52,0,0,0,14-14V81.17Z",
    transform: "translate(-36 -37.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.25 22.57 22.5 34.22 29.25 45.87 42.75 45.87 49.51 34.22 42.75 22.57 29.25 22.57"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProcore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Procore.7d151a92.svg";
export { ForwardRef as ReactComponent };